module.exports = __webpack_public_path__ + "static/img/cash-btn.afa394a.png";